import { catchError as rxjscatchError, map as rxjsmap, throwError as rxjsthrowError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { map } from 'rxjs/operators';
import {
  ActivityHeader,
  FollowUpActivity,
  MultiDeleteResultDto,
  BulkStopRecurringActivitiesResult
} from '../models/activities';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { PaginationRequest } from '../../shared/models/paginationRequest';
import { PagedResponse, ActivityMetadataDto } from '../../shared/models/pagedResponse';
import { ActivityFilterDto } from '../models/activityFilterRequest';
import { ActivityMetadataFilterDto } from '../models/activityMetadataFilterRequest';
import { catchError } from 'rxjs/operators';
import { BaseServices } from '../../kuba.services';

@Injectable()
export class ActivityServices {
  id: number;
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) {}

  /**
   * Validates and adds sorting parameters to HttpParams
   * @param params - Existing HttpParams
   * @param request - PaginationRequest containing sort info
   * @returns Updated HttpParams with sorting parameters
   */
  private addSortingParams(params: HttpParams, request: PaginationRequest): HttpParams {
    let updatedParams = params;

    if (request.sortColumn) {
      updatedParams = updatedParams.set('sortColumn', request.sortColumn);
    }
    if (request.sortDirection) {
      updatedParams = updatedParams.set('sortDirection', request.sortDirection);
    }

    return updatedParams;
  }

  /**
   * Adds filter parameters to HttpParams
   * @param params - Existing HttpParams
   * @param filter - DeviationFilterDto containing filter values
   * @returns Updated HttpParams with filter parameters
   */
  private addFilterParams(params: HttpParams, filter?: any): HttpParams {
    let updatedParams = params;
    
    if (filter) {
      Object.keys(filter).forEach(key => {
        const value = filter[key as keyof any];
        if (value !== undefined && value !== null && value !== '') {
          updatedParams = updatedParams.set(key, value.toString());
        }
      });
    }
    
    return updatedParams;
  }


  // bind business dropdown
  getBusiness() {
    // Use pagination with large page size to get all businesses
    const filter = {
      PageNumber: 1,
      PageSize: 10000, // Large number to get all businesses
      SortColumn: 'CompanyName',
      SortDirection: 'ASC'
    };

    return this.http
      .post<any>(environment.BASE_URL + '/businesses/paged', filter)
      .pipe(
        map((result: any) => result.Items || [])
      );
  }

  getActivityResponsible(businessId: number) {
    return this.http
      .get(`${environment.BASE_URL}/activityResponsible/${businessId}`).pipe(rxjsmap(res => res));
  }
  // List all Activity
  getPortalActiveBusiness() {
    return this.http
      .get(`${environment.BASE_URL}/portalactivebusinesses`).pipe(rxjsmap(res => res));
  }
  // List all business
  activeBusinesslist() {
    // Use faster endpoint for admin and portal levels
    if (BaseServices.roleId === '1' || BaseServices.roleId === '2') {
      return this.http
        .get(environment.BASE_URL + '/businesses/names').pipe(rxjsmap(result => result));
    } else {
      return this.http
        .get(environment.BASE_URL + '/activebusinesses').pipe(rxjsmap(result => result));
    }
  }
  // List all business
  responsiblePersons() {
    return this.http
      .get(environment.BASE_URL + '/responsiblepersons').pipe(rxjsmap((result: any) => result));
  }
  
  deleteactivity(activity: any) {
    return this.http
      .post(environment.BASE_URL + '/activityChildRecorddelete', activity).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  /**
   * stop future recurring
   * @param activityId
   */
  stopFutureRecurring(activityId: any) {
    return this.http
      .get(environment.BASE_URL + '/stopFutureRecurringActivity/' + activityId).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  add(activity: ActivityHeader, applicationId: number) {
    return this.http
      .post(
        environment.BASE_URL + '/followup/postactivity/' + applicationId,
        activity
      ).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  update(activity: FollowUpActivity) {
    return this.http
      .put(environment.BASE_URL + '/followup/putactivity', activity).pipe(rxjsmap(result => result));
  }
  get(id: number) {
    return this.http
      .get(environment.BASE_URL + '/followup/getactivity/' + id).pipe(rxjsmap((res: any) => res));
  }

  delete(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/activitydelete/' + id).pipe(rxjsmap(result => result));
  }

  deleteParentwithRecurring(id: number) {
    return this.http
      .delete(
        environment.BASE_URL + '/followup' + '/deleteParentwithRecurring/' + id
      ).pipe(rxjsmap(result => result));
  }

  getallRepetition() {
    return this.http.get(environment.BASE_URL + '/repetition').pipe(rxjsmap(result => {
      if (result) {
        return result;
      } else {
        return null;
      }
    }));
  }

  getAllFollowUp(id: number) {
    return this.http
      .get(environment.BASE_URL + '/employees/' + id).pipe(rxjsmap(result => result));
  }

  getAllExecution(id: number) {
    return this.http
      .get(environment.BASE_URL + '/employees/' + id).pipe(rxjsmap(result => result));
  }

  getAllRepetition() {
    return this.http
      .get(environment.BASE_URL + '/repetition').pipe(rxjsmap((result: any) => result));
  }

  getActivityLog(businessId: number, id: number) {
    return this.http
      .get(`${environment.BASE_URL}/followup/activitylog/${businessId}/${id}`).pipe(rxjsmap(result => result));
  }

  // bind dropdown Course Name
  getAllByCourseName(id: number) {
    return this.http
      .get(
        environment.BASE_URL +
          '/business/businesscourse/businesscourselist/' +
          id
      ).pipe(rxjsmap(result => result));
  }

  getChecklistsByPortal(portalId: number) {
    return this.http
      .get(`${environment.BASE_URL}/manuals/portallevel/checkLists/${portalId}`).pipe(rxjsmap((result: any) => result));
  }

  createPortalActivityBatch(activityData: FormData) {
    return this.http
      .post(`${environment.BASE_URL}/activityaddportal/batch`, activityData).pipe(rxjsmap((result: any) => result));
  }

  getActivityListPagedByBusinessId(
    request: PaginationRequest,
    activityFilterDto: ActivityFilterDto,
    businessId?: number
  ): Observable<PagedResponse<any>> {
    let params = new HttpParams()
      .set('pageNumber', request.pageNumber.toString())
      .set('pageSize', request.pageSize.toString());

    if (businessId) {
      params = params.set('businessId', businessId.toString());
    }

    params = this.addSortingParams(params, request);

    params = this.addFilterParams(params, activityFilterDto);

    const url = `${environment.BASE_URL}/businessActivities/${businessId}/paged`

    return this.http.get<PagedResponse<any>>(url, { params });
  }

  /**
   * Gets activities metadata for different user roles
   * @param businessId - Business ID for business-level access
   * @param userRole - User role (Admin, Portal, Editor, User, Guest)
   * @param portalId - Portal ID for portal-level access (required for Portal role security)
   * @returns Observable with activities metadata
   */
  getActivitiesMetadata(
    businessId: number,
    userRole: string,
    portalId?: number
  ):  Observable<ActivityMetadataDto> {
    let params = new HttpParams()
      
    if (businessId) {
      params = params.set('businessId', businessId.toString());
    }
    let url = '';
    if (userRole === 'Admnin') {
      url = `${environment.BASE_URL}/admin/activity-metadata/${businessId}`
    } else if (userRole === 'Portal') {
      // For portal level, use portalId instead of businessId for security
      const targetPortalId = portalId || businessId;
      url = `${environment.BASE_URL}/activity-metadata/portal/${targetPortalId}`
    } else {
      url = `${environment.BASE_URL}/activity-metadata/${businessId}`
    } 

    return this.http.get<ActivityMetadataDto>(url, { params });
  }

  /**
   * Gets filtered activities metadata for different user roles
   * @param businessId - Business ID for business-level access
   * @param userRole - User role (Admin, Portal, Editor, User, Guest)
   * @param filter - Filter parameters for metadata
   * @param portalId - Portal ID for portal-level access (required for Portal role security)
   * @returns Observable with filtered activities metadata
   */
  getFilteredActivitiesMetadata(
    businessId: number,
    userRole: string,
    filter?: ActivityMetadataFilterDto,
    portalId?: number
  ): Observable<ActivityMetadataDto> {
    let params = new HttpParams();
    
    // Add filter parameters if provided
    if (filter) {
      if (filter.year !== undefined && filter.year !== null) {
        params = params.set('year', filter.year.toString());
      }
      if (filter.nr) {
        params = params.set('nr', filter.nr);
      }
      if (filter.business) {
        params = params.set('business', filter.business);
      }
      if (filter.title) {
        params = params.set('title', filter.title);
      }
      if (filter.status !== undefined && filter.status !== null) {
        params = params.set('status', filter.status.toString());
      }
      if (filter.department !== undefined && filter.department !== null) {
        params = params.set('department', filter.department.toString());
      }
      if (filter.responsiblePerson) {
        params = params.set('responsiblePerson', filter.responsiblePerson);
      }
      if (filter.responsibleForFollowup !== undefined && filter.responsibleForFollowup !== null) {
        params = params.set('responsibleForFollowup', filter.responsibleForFollowup.toString());
      }
      if (filter.recurrence !== undefined && filter.recurrence !== null) {
        params = params.set('recurrence', filter.recurrence.toString());
      }
      if (filter.description) {
        params = params.set('description', filter.description);
      }
      if (filter.businessById !== undefined && filter.businessById !== null) {
        params = params.set('businessById', filter.businessById.toString());
      }
    }

    let url = '';
    if (userRole === 'Admin') {
      url = `${environment.BASE_URL}/admin/activity-metadata`;
    } else if (userRole === 'Portal') {
      const targetPortalId = portalId || businessId;
      url = `${environment.BASE_URL}/activity-metadata/portal/${targetPortalId}`;
    } else {
      url = `${environment.BASE_URL}/activity-metadata/${businessId}`;
    }

    return this.http.get<ActivityMetadataDto>(url, { params });
  }


   getActivityListPagedByPortalId(
    request: PaginationRequest,
    activityFilterDto: ActivityFilterDto
  ): Observable<PagedResponse<any>> {
    let params = new HttpParams()
      .set('pageNumber', request.pageNumber.toString())
      .set('pageSize', request.pageSize.toString());

    params = this.addSortingParams(params, request);

    params = this.addFilterParams(params, activityFilterDto);

    const url = `${environment.BASE_URL}/portalActivities/paged`
     
    return this.http.get<PagedResponse<any>>(url, { params });
  }

  getAdminActivityListPaged(
    request: PaginationRequest,
    adminActivityFilterDto: ActivityFilterDto
  ): Observable<PagedResponse<any>> {
    let params = new HttpParams()
      .set('pageNumber', request.pageNumber.toString())
      .set('pageSize', request.pageSize.toString());

    params = this.addSortingParams(params, request);

    params = this.addFilterParams(params, adminActivityFilterDto);

    const url = `${environment.BASE_URL}/adminactivities/paged`
     
    return this.http.get<PagedResponse<any>>(url, { params });
  }

  getAdminActivity(applicationId: number) {
    return this.http
      .get(environment.BASE_URL + '/adminactivities/' + applicationId).pipe(rxjsmap((result: any) => result));
  }
  getPortalActivity(userId: number) {
    return this.http
      .get(environment.BASE_URL + '/portalactivities/' + userId).pipe(rxjsmap((result: any) => result));
  }
  getBusinessPortalContacts(appId: number, userId: number) {
    return this.http
      .get(
        environment.BASE_URL + '/businessportalcontacts/' + appId + '/' + userId
      ).pipe(rxjsmap((result: any) => result));
  }

  getActivityCompleteCheckList(activityId: number) {
    return this.http
      .get(
        environment.BASE_URL +
          '/manual/checklist/complete/get/checklistByActivity/' +
          activityId
      ).pipe(rxjsmap(result => result));
  }

  /**
   *
   * @param activityId
   */
  checkParentActivity(activityId: number) {
    return this.http
      .get(environment.BASE_URL + '/followup' + '/parentActivity/' + activityId).pipe(rxjsmap(result => result));
  }

  /**
   * Generates a PDF report for the activity.
   * @param businessId Id of the business.
   * @param activityId Id of the activity.
   * @param cultureInfo Language and culture information.
   * @param userId Id of user.
   * @returns Downloadable PDF blob.
   */
  activityReportGenerate(
    businessId: number,
    activityId: number,
    cultureInfo: string,
    userId: number
  ) {
    let dynamicType = 'application/pdf';
    let myData = JSON.stringify({ data: activityId });
    let url = `${environment.BASE_URL}/export-ActivityPrintDetails/${businessId}/${activityId}/${cultureInfo}/${userId}`;
    let crfToken = this.authenticationService.getCsrfToken();
    return Observable.create(observer => {
      let xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.withCredentials = true;
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Logo-Id', 'ab064fd4-9b4a-4e70-972d-dafdaceb2aba');
      xhr.setRequestHeader('X-XSRF-TOKEN', crfToken);
      xhr.responseType = 'blob';
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            let contentType = dynamicType;
            let blob = new Blob([xhr.response], { type: contentType });
            observer.next(blob);
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.send(myData);
    });
  }

  /**
   * Get all activities for export with filters and sorting for business users
   * @param businessId Business ID
   * @param request Pagination request with sorting
   * @param filter Activity filter DTO
   * @returns Observable with all activities for export
   */
  getAllActivitiesForExport(
    businessId: number,
    request: PaginationRequest,
    filter: ActivityFilterDto
  ): Observable<any[]> {
    // For export, we use the existing paged endpoint with a very large page size
    const exportRequest: PaginationRequest = {
      pageNumber: 1,
      pageSize: 100000, // Increased for large exports
      sortColumn: request.sortColumn,
      sortDirection: request.sortDirection
    };
    
    // Copy filter properties
    const exportFilter = { ...filter };
    
    return this.getActivityListPagedByBusinessId(exportRequest, exportFilter, businessId).pipe(rxjsmap((response: any) => response.Items || [])).pipe(rxjscatchError(this.handleError));
  }

  /**
   * Get all activities for export with filters and sorting for portal users
   * @param request Pagination request with sorting
   * @param filter Activity filter DTO
   * @returns Observable with all activities for export
   */
  getAllActivitiesForExportPortal(
    request: PaginationRequest,
    filter: ActivityFilterDto
  ): Observable<any[]> {
    // For export, we use the existing paged endpoint with a very large page size
    const exportRequest: PaginationRequest = {
      pageNumber: 1,
      pageSize: 100000, // Increased for large exports
      sortColumn: request.sortColumn,
      sortDirection: request.sortDirection
    };
    
    // Copy filter properties
    const exportFilter = { ...filter };
    
    return this.getActivityListPagedByPortalId(exportRequest, exportFilter).pipe(rxjsmap((response: any) => response.Items || [])).pipe(rxjscatchError(this.handleError));
  }

  /**
   * Get all activities for export with filters and sorting for admin users
   * @param request Pagination request with sorting
   * @param filter Activity filter DTO
   * @returns Observable with all activities for export
   */
  getAllActivitiesForExportAdmin(
    request: PaginationRequest,
    filter: ActivityFilterDto
  ): Observable<any[]> {
    // For export, we use the existing paged endpoint with a very large page size
    const exportRequest: PaginationRequest = {
      pageNumber: 1,
      pageSize: 100000, // Reasonable maximum for export
      sortColumn: request.sortColumn,
      sortDirection: request.sortDirection
    };
    
    // Copy filter properties
    const exportFilter = { ...filter };
    
    return this.getAdminActivityListPaged(exportRequest, exportFilter).pipe(rxjsmap((response: any) => response.Items || [])).pipe(rxjscatchError(this.handleError));
  }

  /**
   * Get businesses for portal activities
   * @param portalId Portal ID
   * @param checklistId Optional checklist ID to check if business has it assigned
   * @returns Observable with businesses data
   */
  getBusinessesForPortalActivities(
    portalId: number,
    checklistId?: number
  ): Observable<any> {
    let params = new HttpParams();
    
    if (checklistId) {
      params = params.set('checklistId', checklistId.toString());
    }

    return this.http
      .get(`${environment.BASE_URL}/businessforportalactivities/${portalId}`, { params }).pipe(rxjsmap((result: any) => result));
  }

  /**
   * Delete multiple activities
   * @param activityIds - Array of activity IDs to delete
   * @returns Observable with deletion result
   */
  multiDeleteActivities(activityIds: number[]): Observable<MultiDeleteResultDto> {
    return this.http
      .delete<MultiDeleteResultDto>(`${environment.BASE_URL}/activities/multidelete`, {
        body: activityIds
      });
  }

  /**
   * Stop recurrence for multiple activities
   * @param activityIds - Array of activity IDs to stop recurrence
   * @returns Observable with stop recurrence result
   */
  multiStopRecurrence(activityIds: number[]): Observable<BulkStopRecurringActivitiesResult> {
    return this.http
      .post<BulkStopRecurringActivitiesResult>(`${environment.BASE_URL}/activities/stopFutureRecurringActivities`, activityIds);
  }

  private handleError(error: any) {
    console.error('An error occurred:', error);
    return rxjsthrowError(error.message || error);
  }
}
